// extracted by mini-css-extract-plugin
export default {"pagination":"pagination_pagination__1S+3S","ticketCounterText":"pagination_ticketCounterText__-nvQy"};